import { useFieldArray } from 'react-hook-form';
import { Stack } from '@mui/material';
import { CartRow } from './CartRow';
import { CartState } from '../../../contexts/cart/types';

export const CartTable: React.FC = () => {
  const { fields, remove } = useFieldArray<CartState>({ name: 'items' });
  return (
    <Stack direction="column" gap={1} sx={{ mb: 1 }}>
      {fields.map((item, index) => (
        <CartRow
          key={item.id}
          {...item}
          onDelete={() => remove(index)}
          index={index}
        />
      ))}
    </Stack>
  );
};
